export class WebhookV1PolicyArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "dateCreated",
            "baseName": "dateCreated",
            "type": "WebhookV1ProtobufTimestamp",
            "format": ""
        },
        {
            "name": "dateModified",
            "baseName": "dateModified",
            "type": "WebhookV1ProtobufTimestamp",
            "format": ""
        },
        {
            "name": "userCreatedName",
            "baseName": "userCreatedName",
            "type": "string",
            "format": ""
        },
        {
            "name": "userModifiedName",
            "baseName": "userModifiedName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1PolicyArguments.attributeTypeMap;
    }
    constructor() {
    }
}
